module.exports = __webpack_public_path__ + "static/media/popup-image.1add677f.jpeg";